"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClientsHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="clients-hero" className="relative min-h-[60vh] flex flex-col items-center pt-32 pb-16 bg-background">
      <img src="https://newmavericks.com/wp-content/uploads/2026/03/Clients-served.png" alt="Clients Showcase" width="1200" height="675" className="relative z-10 rounded-xl shadow-strong w-full max-w-[1000px] px-4 ![margin:20px_0px_0px_0px]" />
    </section>;
}